import { AgendamentoMTService } from "./../../../agendamento-vistorias/agendamento-mt-form/agendamento-mt.service";
import { Input, Injectable, Directive } from "@angular/core";
import { AgendamentoTipoEnum } from "app/compartilhado/servicos/global.service";
import { Subject } from "rxjs";
import { InterceptorService } from "../../../interceptor-service";
import { AgendamentoESService } from "app/agendamento-vistorias/agendamento-es-form/agendamento-es.service";

export class PopModel {
  // classe com os atributos do pop-up
  public title: string; // titulo do pop-up
  public text: string; // texto do pop-up
  public optionalText?: string;
  public optionalInfo?: string;
  public fa_class: string; // classe do icone [(i)(v)(!)(x)(?)]
}

export class PopAgendamentoModel {
  // classe com os atributos do pop-up
  public Placa: string;
  public Renavam: string;
  public Nome: string;
  public CpfCnpj: string;
  public Telefone: string;
  public Email: string;
  public VeiculoPorte: string;
  public DataInicio: string;
  public TipoVistoria: string;
  public Municipio: string;
  public Uf: string;
  public LocalVistoria: string;
  public HorarioInicio: string;
}

@Directive()
@Injectable()
export class PopUpService {
  @Input() esconderTemplateAuto = true; // var utilizada para esconder o pop-up template quando a tela estiver grande
  templateIsShowing = false; // indica se o pop-up template está sendo exibido
  templateHasToComeBack = false; // indica se o pop-up template deve voltar ao fechar o pop-up-alerta

  templateSub = new Subject<boolean>(); // subject de pop-up template (true mostra, false esconde)
  respostaSub = new Subject<boolean>(); // subject de resposta (tambem vale para o simples, basta utilizar)
  respostaSubOk = new Subject<boolean>(); // subject de resposta (tambem vale para o simples, basta utilizar)
  notificaSub = new Subject<PopModel>(); // subject de pop-up simples
  perguntaSub = new Subject<PopModel>(); // subject de pop-up de pergunta
  perguntaSub2 = new Subject<PopModel>(); // subject de pop-up de pergunta alternativa
  agendadoChanged = new Subject<any>();
  agendamentoSub = new Subject<any>();
  agendadoSub = new Subject<boolean>();
  agendadoMTSub = new Subject<any>();
  agendadoESSub = new Subject<any>();
  agendamentoRespostaSub = new Subject<any>();
  sairRespostaSub = new Subject<any>();
  informacoesSub = new Subject<any>();
  atualizarDadosSub = new Subject<any>();
  popFechouSub = new Subject<any>(); // subject para quando o pop-up fechar (permite a execução de funções que dependem desse evento)
  popDados = new PopModel(); // objeto do PopModel (titulo, texto e icone)
  acessoEncerradoChanged = new Subject<boolean>(); // subject de pop-up simples
  confirmaInformacaoPIChanged = new Subject<boolean>();
  confirmaInformacaoGOChanged = new Subject<boolean>();
  confirmaInformacaoMTChanged = new Subject<boolean>();
  confirmaInformacaoESChanged = new Subject<boolean>();
  detranEstadoDescricao = "DETRAN";
  agendamentoTipo: AgendamentoTipoEnum;
  agendamentoMTService: AgendamentoMTService;
  agendamentoESService: AgendamentoESService;

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
    Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor() {}

  // (i) pop-up Info
  showPopInfo(
    title: string,
    text: string,
    optionalText?: string,
    optionalInfo?: any
  ) {
    if (optionalText && optionalInfo) {
      this.popDados = {
        title,
        text,
        optionalText,
        optionalInfo,
        fa_class: "fa fa-info-circle",
      };
    } else {
      this.popDados = { title, text, fa_class: "fa fa-info-circle" };
    }
    this.notificaSub.next(this.popDados);
  }

  showPopConfirmaAgendamento(campos) {
    this.agendamentoSub.next(campos);
  }

  showPopInformacoes() {
    this.informacoesSub.next();
  }

  atualizarDados(campos) {
    this.atualizarDadosSub.next(campos);
  }

  showPopAgendado(modoAgendado) {
    this.agendadoSub.next(modoAgendado);
  }

  showPopAgendadoMT(modalAgendamento) {
    this.agendadoMTSub.next(modalAgendamento);
  }

  showPopAgendadoES(modalAgendamento) {
    this.agendadoESSub.next(modalAgendamento);
  }

  showBotaoComprovante() {
    this.agendadoChanged.next(true);
  }

  // (v) pop-up Confirm
  showPopConfirm(title: string, text: string) {
    this.popDados = { title, text, fa_class: "fa far fa-check-circle" };
    this.notificaSub.next(this.popDados);
  }

  // (!) pop-up Warning Custom
  showCustomPopWarning(title: string, text: string) {
    this.popDados = { title, text, fa_class: "fas fa-exclamation-triangle" };
    this.notificaSub.next(this.popDados);
  }

  // (!) pop-up Warning
  showPopWarning(tipo: string) {
    switch (tipo) {
      case "CamposObrigatórios":
        this.popDados = {
          title: "Consulta de registro",
          text: "Preencha todos os campos obrigatórios corretamente!",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "CamposObrigatóriosSalvar":
        this.popDados = {
          title: "Falha ao Salvar",
          text: "Preencha todos os campos obrigatórios corretamente!",
          fa_class: "far fa-frown",
        };
        break;
      case "InformacaoInvalida":
        this.popDados = {
          title: "Falha ao salvar",
          text: "3905 - Existe informação inválida na solicitação.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "PlacaInválida":
        this.popDados = {
          title: "Falha ao pesquisar",
          text: "2084 - Placa inválida, por favor informe uma placa com 7 dígitos.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "DataInicialMaiorQueFinal":
        this.popDados = {
          title: "Falha ao consultar",
          text: "2018 - Data inicial não pode ser maior que a data final! Por favor informe outra data.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "DataInicialInválida":
        this.popDados = {
          title: "Consulta de registro",
          text: "2002 - O período informado está inválido, verifique.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "IpInvalido":
        this.popDados = {
          title: "Falha ao salvar",
          text: "3012 - O IP informado apresenta um formato inválido.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "DescricaoInvalida":
        this.popDados = {
          title: "Falha ao salvar",
          text:
            "3905 - Existe informação inválida na solicitação:\n" +
            "Descrição requerida",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "MensagemInvalida":
        this.popDados = {
          title: "Falha ao salvar",
          text:
            "3905 - Existe informação inválida na solicitação:\n" +
            "Mensagem requerida",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "DataFinalInválida":
        this.popDados = {
          title: "Consulta de registro",
          text: "A Data final não foi preenchida corretamente!",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "HoraInicialMaiorQueFinal":
        this.popDados = {
          title: "Consulta de registro",
          text: "2044 - Hora inicial não pode ser maior que a hora final. Por favor, informe outro horário.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "HoraInicialInválida":
        this.popDados = {
          title: "Consulta de registro",
          text: "A Hora inicial não foi preenchida corretamente!",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "HoraFinalInválida":
        this.popDados = {
          title: "Consulta de registro",
          text: "A Hora final não foi preenchida corretamente!",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "HoraInvalida":
        this.popDados = {
          title: "Consulta de registro",
          text: "O campo de hora não foi preenchido corretamente!",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "DataInvalida":
        this.popDados = {
          title: "Consulta de registro",
          text: "2002 - O período informado está inválido, verifique.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "SemDados":
        this.popDados = {
          title: "Consulta de registro",
          text: "2011 - Faça uma pesquisa e selecione um registro para a operação.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "SemDadosExportar":
        this.popDados = {
          title: "Atenção",
          text: "Não existem dados para serem exportados.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "SelecioneRegistro":
        this.popDados = {
          title: "Consulta de registro",
          text: "2010 - Nenhum registro foi selecionado para a operação.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "LaudoFormataçãoErrada":
        this.popDados = {
          title: "Consulta de registro",
          text: "2065 - Número do laudo na formatação errada. Ex: 12345678-90 ou para Prodesp: SP000000000-12/2016 ",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "IntervaloMaiorQue31Dias":
        this.popDados = {
          title: "Falha ao consultar",
          text: "2081 - As datas informadas não podem exceder o período de 31 dias.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "IntervaloMaiorQue7Dias":
        this.popDados = {
          title: "Consulta de registro",
          text: "2081 - As datas informadas não podem exceder o período de 7 dias.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "IntervaloMaiorQue30Dias":
        this.popDados = {
          title: "Falha ao consultar",
          text: "2041 - O período não pode exceder 30 dias.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "CnpjInvalido":
        this.popDados = {
          title: "Falha ao consultar",
          text: "2022 - Informe um CNPJ válido.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "CpfInvalido":
        this.popDados = {
          title: "Falha ao consultar",
          text: "2026 - Informe um CPF válido.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "SenhasDiferentes":
        this.popDados = {
          title: "Falha ao consultar",
          text: "3905 - As senhas digitadas não são iguais.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "ObjetoNaoMudou":
        this.popDados = {
          title: "Consulta de registro",
          text: "??? - Altere algum dado para fazer a pesquisa.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "InformeEcv":
        this.popDados = {
          title: "Falha ao consultar",
          text: "2020 - É necessário informar uma ECV para realizar a consulta.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "RptNaoSelecionado":
        this.popDados = {
          title: "Falha ao carregar",
          text: "3026 - Não há arquivos válidos para upload, favor selecionar um RPT válido.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "CsvNaoSelecionado":
        this.popDados = {
          title: "Falha ao carregar",
          text: "3027 - Não há arquivos para upload, favor selecionar um CSV válido.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "PesquisaVazia":
        this.popDados = {
          title: "Atenção",
          text: "2089 - O relatório não possui registros para serem exportados.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "DocumentoNaoSelecionado":
        this.popDados = {
          title: "Falha ao carregar",
          text: "3008 - Nenhum documento foi selecionado.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "ValidadeInvalida":
        this.popDados = {
          title: "Falha ao salvar",
          text: "A validade é invalida!",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "UfNaoSelecionada":
        this.popDados = {
          title: "Falha ao atualizar lista",
          text: "Selecione a UF desejada",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
      case "SemIntervaloDeAgendamento":
        this.popDados = {
          title: "Atenção",
          text: "2107: Atualmente, o local de vistoria selecionado não possui dias disponíveis para agendamento.<br>Em caso de dúvidas entre em contato com a ECV.",
          fa_class: "fas fa-exclamation-triangle",
        };
        break;
    }
    this.notificaSub.next(this.popDados);
  }

  // (x) pop-up Erro
  showPopError(title: string, text: string) {
    this.popDados = { title, text, fa_class: "fa fa-times-circle" };
    this.notificaSub.next(this.popDados);
  }

  // (?) pop-up Pergunta
  showPopQuestion(title: string, text: string) {
    this.popDados = { title, text, fa_class: "fa fa-question-circle" };
    this.perguntaSub.next(this.popDados);
  }

  // (?) pop-up Pergunta alternativa
  showPopQuestion2(title: string, text: string) {
    this.popDados = { title, text, fa_class: "fa fa-question-circle" };
    this.perguntaSub2.next(this.popDados);
  }

  // Mostra o pop-up Template
  showPopTemplate() {
    this.templateSub.next(true);
  }

  // Esconde o pop-up Template
  hidePopTemplate() {
    this.templateSub.next(false);
  }
}
